function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.352 4.063l-8-3a1.009 1.009 0 00-.7 0l-8 3A1 1 0 003 5v7c0 6.543 8.2 10.72 8.553 10.9a1 1 0 00.894 0C12.8 22.72 21 18.543 21 12V5a1 1 0 00-.648-.937z",
  fill: "#fff"
});

var SvgIconShield = function SvgIconShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZGVmcz48c3R5bGU+LmEsLmJ7ZmlsbDojZmZmfS5he29wYWNpdHk6MH08L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTAgMGgyNHYyNEgweiIvPjxwYXRoIGNsYXNzPSJiIiBkPSJNMjAuMzUyIDQuMDYzbC04LTNhMS4wMDkgMS4wMDkgMCAwIDAtLjcgMGwtOCAzQTEgMSAwIDAgMCAzIDV2N2MwIDYuNTQzIDguMiAxMC43MiA4LjU1MyAxMC45YTEgMSAwIDAgMCAuODk0IDBDMTIuOCAyMi43MiAyMSAxOC41NDMgMjEgMTJWNWExIDEgMCAwIDAtLjY0OC0uOTM3eiIvPjwvc3ZnPg==";
export { SvgIconShield as ReactComponent };